export default __webpack_public_path__ + "static/media/rank-5.ae3243b3.webp";